module.exports = __webpack_public_path__ + "img/t3-3.d18bfc7b.svg";